import React from "react";
import { Navigation } from '../components/Navigation';


export const APIDocumentation = () => {
    return (
        <>
            <Navigation />
            <div className="header gradient">
                <div className='nav-header'></div>
            </div>
        </>
    )
}